export default {
  methods: {
    getLocalizedContent(data, attr) {
      // Überprüfe, ob 'data' und 'attributes' existieren
      if (!data) {
        return ""; // Fallback-Wert, wenn Daten nicht existieren
      }

      // Prüfe, ob es sich um Deutsch handelt
      if (this.curLang === "de") {
        return data[attr] || ""; // Gebe das Attribut zurück, falls vorhanden
      }

      // Prüfe, ob Lokalisierungen vorhanden sind
      return data.localizations?.data[0]?.attributes[attr] || "";
    },
  },
};
